export default function ServiceLabel({ text, boldText }) {
  return <span>{text} - <b>{boldText}</b></span>;
}